import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {WorldMapService} from '../../../services/world-map.service';
import * as fromStore from '../../../store';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import {WorldMap} from '../world-map.model';
import {Update} from '@ngrx/entity';

@Injectable()
export class WorldMapEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private worldMapService = inject(WorldMapService);

  constructor() {}

  ReadWorldMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.WorldMapActionTypes.GetWorldMaps),
    map((action: featureActions.GetWorldMaps) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) =>　{
      const params = (payload !== null && payload.regionIds !== null && payload.regionIds !== undefined) ?
                    {otp: user.otp, acode: user.acode, RegionIds: payload.regionIds} : {otp: user.otp, acode: user.acode};
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.GetWorldMap
      };
      return this.worldMapService.ReadWorldMap(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            if (Array.isArray(res.msg.body)) {
              return [new featureActions.LoadWorldMaps({worldMaps: res.msg.body}), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
            } else {
              return [new featureActions.LoadWorldMaps({worldMaps: []}), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
            }
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
          // throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
          catchError(error => {
            const updateRes: UpdateInfoModel = {
              result: false,
              errmsg: 'Error',
              type: updateInfoType.GetWorldMap
            };
            return [new featureActions.UpdateInfoFailAction(updateRes), new featureActions.LoadWorldMaps({worldMaps: []})];
          })
      );
    })
  ));
  AddWorldMap = createEffect(() => this.actions$.pipe(
    ofType(featureActions.WorldMapActionTypes.GetAddWorldMaps),
    map((action: featureActions.GetAddWorldMaps) => action.payload.worldMaps),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {...payload};
      params.otp = user.otp;
      return this.worldMapService.AddWorldMap(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.AddWorldMap };
          if (result.result) {
            const updatedPayload = { ...payload, Id: result.msg['body'] };
            return [new featureActions.AddWorldMap({worldMap: updatedPayload}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddWorldMap
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  UpdateWorldMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.WorldMapActionTypes.GetUpdateWorldMaps),
    map((action: featureActions.GetUpdateWorldMaps) => action.payload.worldMaps),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {...payload};
      params.otp = user.otp;
      return this.worldMapService.UpdateWorldMap(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.EditWorldMap };
          if (result.result) {
            const update: Update<WorldMap> = {
              id: payload.id,
              changes: { ...payload }
            };
            return [new featureActions.UpdateWorldMap({worldMap: update}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.EditWorldMap
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  DeleteWorldMap$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.WorldMapActionTypes.GetDeleteWorldMaps),
    map((action: featureActions.GetDeleteWorldMaps) => action.payload.id),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([id, user]) => {
      const params = {
        otp: user.otp,
        id: Number(id)
      };
      return this.worldMapService.DeleteWorldMap(params).pipe(
        switchMap((res: any) => {
          const result = { ...res, type: updateInfoType.DeleteWorldMap };
          if (result.result) {
            return [new featureActions.DeleteWorldMap({id: id}), new featureActions.UpdateInfoSuccessAction(result)];
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteWorldMap
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
